import React from 'react';
import {
  OwcButton,
  OwcExpandable,
  OwcInput,
  OwcTypography,
  OwcModalDialog,
  OwcCheckbox,
  OwcTable,
  OwcTableHeader,
  OwcTableHeaderCell,
  OwcTableBody,
  OwcTableRow,
  OwcTableCell,
  OwcProgressBar,
  OwcPagination,
  OwcComponentFooter,
  OwcSelectDropdown,
  OwcListItem
} from '@one/react';
import { configData } from '../../../config.js';
import { fetchSigned , checkForCompletion, formatDate } from "../../../shared/Utilities.js"
import AgreementSelection from '../../useCase/AgreementSelection.js';
import AgreementDisplayList from '../../useCase/AgreementDisplayList.js';
import CountrySelector from '../../general/CountrySelector.js';
import SimpleDateInput from '../../general/SimpleDateInput.js';
import CopyToClipboardButton from '../../general/CopyToClipboardButton.js';

const FILTER_OPTIONS = {
  ALL: "all",
  COVERED: "covered",
  NOT_COVERED: "notCovered",
};


const BASE_URL = configData.LOCATION_ACCOUNT_COVERAGE_URL;//added location url in config

class LocationCoverageReport extends React.Component {
  constructor(props) {
    super(props);

    this.cancelRequested = React.createRef();
    this.cancelRequested.current = false;

    this.state = {
      countryList: [],
      countrySelectorVisible: false,
      agreementList: [],
      resetAgreementControl: Math.random(),
      selectedAffiliate: 0,
      publishedOnly: 'Published Only',
      lastUploadSince: null,  
      installDateSince: null,
      affiliateList: [],
      installDateBlank: true,
      installDateBlankEnabled: false,
      reportResults: null,
      userMessage: null,
      isLoadingResults: false, 
      reportSpecExpanded:true,
      selectedOption: FILTER_OPTIONS.ALL,
      sortBy: "locationAccountName",
      sortOrder: "default",
      currentPage: 1,
      pageSize: 50,
    };
  }


  componentDidMount() {
    const baseUrl = BASE_URL;
    const labelUrl = baseUrl + "label/";
    fetchSigned(labelUrl)
      .then(async response => {
        let responseDict = {};

        if (response !== undefined) {
          const contentType = response.headers.get("content-type");
          if (contentType && contentType.indexOf("application/json") !== -1) {
            responseDict = await response.json();
          } else {
            console.log(response)
          }
        }
        this.setState({ label: responseDict });
      })
      .catch(error => {
        this.setState({ responseText: error.toString() });
        console.error('There was an error!', error);
      });

      // load the reference system type data
      fetchSigned(configData.REFDATA_API_URL + "?includeInactive=false")
        .then(res => res.json())
        .then(
          (result) => {
            const filteredAffiliateList = result.filter(value =>
              value.type === "Affiliate"
            );
  
            this.setState({
                affiliateList: filteredAffiliateList
              }
            );
          },
          // Note: it's important to handle errors here
          // instead of a catch() block so that we don't swallow
          // exceptions from actual bugs in components.
          (error) => {this.setState({error})}
        );
  }

  static getDataProductName() {
    return 'Location Coverage Report';
  }

  /* =========================
     Helpers
     ========================= */

     generateCSV = (accounts, type) => {
  // type: 'accounts' or 'devices'
  let csvContent = "";

  if (type === "accounts") {
    // CSV header
    csvContent = "Account No,Name,Address\n";

    accounts.forEach((acc) => {
      const row = [
        acc.accountDetails?.locationAccountNumber ?? "",
        acc.accountDetails?.locationAccountName ?? "",
        acc.accountDetails?.address ?? "",
      ];
      csvContent += row.map((v) => `"${v}"`).join(",") + "\n"; // wrap in quotes for safety
    });
  } else if (type === "devices") {
    // CSV header
    csvContent = "Account No,Device Name,Covered By Agreement\n";

    accounts.forEach((acc) => {
      // Covered devices
      acc.devicesCoveredByAgreements?.forEach((device) => {
        csvContent += `"${acc.accountDetails?.locationAccountNumber ?? ""}","${device}","Yes"\n`;
      });

      // Not covered devices
      acc.devicesNotCoveredByAgreements?.forEach((device) => {
        csvContent += `"${acc.accountDetails?.locationAccountNumber ?? ""}","${device}","No"\n`;
      });
    });
  }

  return csvContent;
};

downloadCSV = (filename, content) => {
  const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

generateDevicesCSV = (data) => {
  if (!data.length) return;

  const headers = [
    "Serial No",
    "Reference System Type",
    "Device ID",
    "First Seen At Location",
    "Last Upload Date",
    "Material No",
    "Material Name",
    "Ship To Account",
    "Sold To Account",
    "Bill To Account",
    "Instrument Location Account",
    "Location Account Name",
    "Location Account Address",
    "Install Date",
    "Placement Type",
    "Coverage Type"
  ];

  const csvRows = [
    headers.join(','),
    ...data.map(row => [
      row.serialNo,
      row.referenceSystemType,
      row.deviceId,
      formatDate(row.firstSeenAtLocation),
      formatDate(row.lastUploadDate),
      row.materialNo,
      row.materialName,
      row.shipToAccount,
      row.soldToAccount,
      row.billToAccount,
      row.instrumentLocation,
      row.locationAccountName,
      row.locationAccountAddress,
      formatDate(row.installDate),
      row.placementType,
      row.coverageType
    ].map(val => `"${val ?? ''}"`).join(','))
  ];

  const blob = new Blob([csvRows.join('\n')], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = 'devices.csv';
  a.click();

  window.URL.revokeObjectURL(url);
};

downloadDevices = (locationAccounts) => {
  const uniqueMap = new Map();

  locationAccounts.forEach(account => {

    const allDevices = [
      ...(account.devicesNotCoveredByAgreements || []),
      ...(account.devicesCoveredByAgreements || [])
    ];

    allDevices.forEach(device => {
      if (!uniqueMap.has(device.deviceId)) {
        uniqueMap.set(device.deviceId, {
          serialNo: device.serialNumber || '',
          referenceSystemType: device.referenceSystemType || '',
          deviceId: device.deviceId || '',
          firstSeenAtLocation: formatDate(device.firstSeenAtLocation) || '',
          lastUploadDate: formatDate(device.lastUploadDate) || '',
          materialNo: device.materialNumber || '',
          materialName: device.materialName || '',
          shipToAccount: device.shipToAccountNumber || '',
          soldToAccount: device.soldToAccountNumber || '',
          billToAccount: device.billToAccountNumber || '',
          instrumentLocation: device.locationAccountNumber || '',
          locationAccountName: device.locationAccountName || '',
          locationAccountAddress: device.instrumentLocation || '',
          installDate: formatDate(device.installDate) || '',
          placementType: device.placementType || '',
          coverageType: account.devicesCoveredByAgreements?.includes(device)
            ? 'Covered'
            : 'Not Covered'
        });
      }
    });
  });

  // Convert Map to array for CSV
  const devicesArray = Array.from(uniqueMap.values());
  this.generateDevicesCSV(devicesArray);
};



copyDevicesToClipboard = (devices = []) => {
  if (!devices.length) return;

  // Make CSV-ready format (Google Sheets friendly)
  const header = Object.keys(devices[0] || {}).join(",");
  const rows = devices.map(device =>
    Object.values(device)
      .map(val => `"${String(val ?? "").replace(/"/g, '""')}"`)
      .join(",")
  );

  const csvContent = [header, ...rows].join("\n");

  navigator.clipboard.writeText(csvContent)
    .then(() => {
      console.log("Copied to clipboard");
    })
    .catch(err => {
      console.error("Copy failed", err);
    });
};

     handleDropdownChange = (ev) => {
    this.setState({ selectedOption: ev.detail.value });
  }

  formatDevicesForClipboard = (devices = []) => {
  if (!devices.length) return "";

  const header = [
    "Serial No",
    "Ref System Type",
    "Device ID",
    "First Seen At Location",
    "Last Upload Date",
    "Material No",
    "Material Name",
    "Ship To Account",
    "Sold To Account",
    "Bill To Account",
    "Instrument Location Account",
    "Location Account Name",
    "Location Account Address",
    "Install Date",
    "Placement Type"
  ].join("\t");

  const rows = devices.map(device =>
    [
      device.serialNumber ?? "",
      device.referenceSystemType ?? "",
      device.deviceId || "",
      formatDate(device.firstSeenAtLocation) ?? "",
      formatDate(device.lastUploadDate) ?? "",
      device.materialNumber ?? "",
      device.materialName ?? "",
      device.shipToAccountNumber ?? "",
      device.soldToAccountNumber ?? "",
      device.billToAccountNumber ?? "",
      device.locationAccountNumber ?? "",
      device.locationAccountName ?? "",
      device.instrumentLocation ?? "",
      formatDate(device.installDate) ?? "",
      device.placementType ?? ""
    ]
      .map(val => String(val).replace(/\t/g, " "))
      .join("\t")
  );

  return [header, ...rows].join("\n");
};

  handleCountrySelectionChange = (selectedCountryCodes) => {
    this.setState({ countryList: selectedCountryCodes });
    console.log("selectedCountryCodes", selectedCountryCodes);
  };

  /* =========================
     Data Fetching Logic
     ========================= */
  get_report_parameters() {
    const parameters_dict = {};
    if (this.state.lastUploadSince !== null) {
      parameters_dict["lastUploadSince"] = this.state.lastUploadSince;
    }
    if (this.state.installDateSince !== null) {
      parameters_dict["installDateSince"] = this.state.installDateSince;
    }
    if (this.state.installDateBlank === true) {
      parameters_dict["installDateBlank"] = "included";
    }
    if (this.state.countryList.length !== 0) {
      parameters_dict["countryList"] = this.state.countryList;
    }
    if (this.state.selectedAffiliate !== 0) {
      parameters_dict["affiliateId"] = this.state.selectedAffiliate;
    }
    if (this.state.publishedOnly !== null) {
      parameters_dict["published"] = this.state.publishedOnly;
    }
    if (this.state.agreementList.length !== 0) {
  parameters_dict["agreementList"] =
    this.state.agreementList
      .map(a => a.customerAgreementId)
      .join(",");
}
    console.log(parameters_dict);
    if (!parameters_dict) {
      return null;
    }
    else {
      const parameters = "?" + Object.keys(parameters_dict).map( function(key){ return key+"="+parameters_dict[key] }).join("&") //outputs "foo=0&bar=1"
      
      console.log(parameters);
      return parameters;
    }
  }


  handleFormClear = () => {
    this.setState({
      countryList: [],
      countrySelectorVisible: false,
      agreementList: [],
      resetAgreementControl: Math.random(),
      selectedAffiliate: 0,
      publishedOnly: 'Published Only',
      lastUploadSince: null,  
      installDateSince: null,
      installDateBlank: true,
      installDateBlankEnabled: false,
      reportResults: null,
      userMessage: null,
    });
  }

   /**
   * Signs and sumbits the request and populates the response
   */
  handleSubmitClick = () => {
    const parameters = this.get_report_parameters();
    this.cancelRequested.current = false;
    this.setState({
       isLoadingResults: true,          
    reportResults: null,      
    userMessage: null,
    reportSpecExpanded:true
    });
    
    let urlToFetch = BASE_URL;
    if ((parameters !== null) && (parameters !== undefined)) {
      urlToFetch += parameters;
    }

    if ((this.props.userName !== null) && (this.props.userName !== undefined)) {
      // Add user data for DP tracking
      urlToFetch += ([null, undefined, ""].includes(parameters) ? "?" : "&");
      urlToFetch += `userName=${this.props.userName}`;
    }

    console.log(`Fetching URL: ${urlToFetch}`);
    fetchSigned(urlToFetch)
      .then(async response => {
        let responseDict = {};
        if (response === undefined || !response.ok) {
          this.setState({
            userMessage: this.formatUserMessage("There was an error requesting the data product")
          });
        } else {
          const contentType = response.headers.get("content-type");
          if (contentType && contentType.indexOf("application/json") !== -1) {
            responseDict = await response.json();
            if (this.cancelRequested.current === false) {
              this.handleDataProductWait(responseDict);
            }
          } else {
            this.setState({
              isLoadingResults:false,
              userMessage: this.formatUserMessage(`The request to generate the data product failed with the message '${await response.text()}'`),
            });
          }
        }   
      })
      .catch(error => {
        this.setState({ userMessage: this.formatUserMessage(error.toString()) });
        console.error('There was an error!', error);
      });
  }

 async handleDataProductWait(responseDict) {
  console.log("Generating Location Coverage Report");

  const requestResult = await checkForCompletion(
    `${BASE_URL}status/${responseDict}`,
    this.cancelRequested,
  );

  if (requestResult.status === "SUCCEEDED") {
    this.getResults(requestResult.resultUrl);
  } else {
    this.setState({
      userMessage: this.formatUserMessage(
        `The request to generate the data product failed with the status '${requestResult.status}'`
      ),
      isLoadingResults: false,   // ✅ STOP LOADER HERE
    });
  }
}


  /**
   * Loads the data product and displays it
   * @param {*} resultsURL 
   */
  getResults(resultsURL){
    console.log(`Reading Data Product from URL ${resultsURL}`);
    fetch(resultsURL,{
      method: "GET",
      headers: {'Accept': '*/*'},
      mode: "cors",
      cache: "no-cache",
      referrer: "client",
    })
    .then(async response => {
      if (response === undefined || !response.ok) {
        this.setState({userMessage: this.formatUserMessage(`There was an error (${response.status}) retrieving from the url ` + resultsURL + response.statusText)});
      } else {
        let reportResults = "";
        reportResults = await response.json();
        this.setState({
  reportResults: reportResults,
  userMessage: null,
  isLoadingResults: false,    
  reportSpecExpanded:false
});
      }
    })
    .catch(error => {
      this.setState({ userMessage: this.formatUserMessage(error.toString()),isLoadingResults:false });
      console.error('There was an error!', error);
    });
  }

  handleRequestCancel = () => {
    this.cancelRequested.current = true;
    this.setState({ userMessage: {error:"Request was cancelled."} });
  }

  formatUserMessage(message, messageType = "error") {
    return { 
      message: message,
      type: messageType,
    };
  }

  /**
   * Download a file of the response
   */
  downloadFile() {
    let extension = ".json";
    let contentType = "application/json";
    const fileName = "location-coverage-report" + extension;
    const blob = new Blob([JSON.stringify(this.state.reportResults)], { type: contentType });
    this.saveFile(blob, fileName);
  }


  /**
   * An internal method to allow instanteous downloads
   * @param {*} blob the data to download
   * @param {*} filename the filename to use
   */
  saveFile = async (blob, filename) => {
    const a = document.createElement('a');
    a.download = filename;
    a.href = URL.createObjectURL(blob);
    a.addEventListener('click', (e) => {
      setTimeout(() => URL.revokeObjectURL(a.href), 30 * 1000);
    });
    a.click();
  };


  renderUserMessage() {
    const message = this.state.userMessage;
    if (message !== null) {
      return(
        <div style={{ marginLeft: "2em", marginRight: "2em"}}>
                  <OwcExpandable roundedControl variant="transparent"
                      expanded={this.state.messageExpanded}
                      onExpandedChange={(ev) => { this.setState({ messageExpanded: ev.detail }) }}>
                    <span slot="title">
                      <OwcTypography variant="title6">
                        {message.type === "error"? "An error occurred": "Process Message"}
                      </OwcTypography>
                    </span>
                    <span slot="content">
                      <OwcTypography variant="title7" style={{ marginLeft: "2em", marginRight: "2em"}}>
                        {message.message}
                      </OwcTypography>
                    </span>
                  </OwcExpandable>
                </div>
      );
    } else {
      return("");
    }
  }

  renderLoadingSection() {
  return (
    <div style={{
      padding: "3rem",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "1rem"
    }}>
      <OwcTypography>
        Generating data product...
      </OwcTypography>

      <div style={{ width: "300px" }}>
        <OwcProgressBar indeterminate />
      </div>
    </div>
  );
}

  /* =========================
     Label helpers
     ========================= */

  getDescriptionFromLabel() {
    const { label } = this.state;

    if (!label || Object.keys(label).length === 0) return null;

    const attrs =
      label?.[configData.LABEL_KEYS.DATA_PRODUCT_ATTRIBUTES_KEY]?.[
        configData.LABEL_KEYS.CHILDREN_KEY
      ];

    return (
      attrs?.[configData.LABEL_KEYS.DESCRIPTION_KEY]?.[
        configData.LABEL_KEYS.VALUE_KEY
      ] || null
    );
  }

  /* =========================
     UI Sections
     ========================= */

  renderLabeledRow(title, content) {
    return (
      <div
        style={{
          display: 'flex',
          border: '1px solid var(--one-color-background-intensity-low)',
          
        }}
      >
        <div
          style={{
            backgroundColor: 'var(--one-color-background-intensity-low)',
            padding: '0.5em',
            minWidth: '150px',
            minHeight: '2em', 

          }}
        >
          <OwcTypography variant="title6">{title}</OwcTypography>
        </div>

        <div style={{ padding: '0.5em', width: '100%' }}>{content}</div>
      </div>
    );
  }

  renderDescriptionSection() {
    const description = this.getDescriptionFromLabel();
    // if (!description) return null;

    return this.renderLabeledRow(
      'Description',
      <OwcTypography>{description}</OwcTypography>
    );
  }

  renderCountryFilterSection() {
    const { countryList } = this.state;

    return this.renderLabeledRow(
      'Country Filter',
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5em' }}>
        <OwcButton
          onclick={() => this.setState({ countrySelectorVisible: true })}
        >
          Click to select countries
        </OwcButton>

        <OwcInput
          cols="80"
          rows="3"
          type="textarea"
          disabled
          no-clear-icon
          resizable="false"
          label={
            countryList.length === 0
              ? 'No countries selected - The report will be global'
              : `${countryList.length} ${
                  countryList.length === 1 ? 'country' : 'countries'
                } selected`
          }
          value={countryList}
        />
      </div>
    );
  }

  renderDeviceFilters(){
    return(
      <div>
          <div style={{width:'100%',backgroundColor: 'var(--one-color-background-intensity-low)',}}>
              <OwcTypography style={{padding:'0.1rem'}} variant="title6">Device Filters</OwcTypography>
          </div>
          <div>
              <OwcTypography style={{margin:'0.1rem 0px',fontWeight:'500'}}>Devices to include</OwcTypography>
            <table>
              <tr >
                <td valign='top'>
                  <OwcTypography style={{paddingTop:"0.8em"}}>Last Upload Since</OwcTypography>
                </td>
                <td valign='top'>
                        <SimpleDateInput label="Date" value={this.state.lastUploadSince}
                          placeholder="Enter date"
                          onValueChange={(ev) => this.setState({ lastUploadSince: ev })}
                          showExampleDate={true}>
                        </SimpleDateInput>
                </td>
                <td valign='top'></td>
              </tr>
              <tr>
                <td valign='top'>
                  <OwcTypography style={{paddingTop:"0.8em"}}>Install Date Since</OwcTypography>
                </td>
                <td valign='top'>
                  <SimpleDateInput label="Date" value={this.state.installDateSince}
                    placeholder="Enter date"
                    onValueChange={(ev) => {
                      const changes = { installDateSince: ev};
                        console.log(ev);
                      if (ev === null || ev.length === 0){
                        changes.installDateBlankEnabled = false;
                      } else {
                        changes.installDateBlankEnabled = true;
                      }
                      this.setState(changes)}}
                    showExampleDate={true}>
                  </SimpleDateInput>
                </td>
                <td valign='top'>
                  <OwcCheckbox  style={{paddingTop:"0.2em"}}
                    onValueChange={(ev)=>{this.setState({installDateBlank: ev.detail});
                  console.log(ev.detail)}}
                    disabled={!this.state.installDateBlankEnabled}
                    checked={this.state.installDateBlank}
                  >Include blank install dates</OwcCheckbox>
                </td>
              </tr>
            </table>
          </div>
      </div>
    )
  }

 renderAgreementFilterSection() {
  const { agreementList, selectedAffiliate, publishedOnly, affiliateList } = this.state;
  return (
    <div>
      {/* Top Grey Header Bar */}
      <div style={{width:'100%',backgroundColor: 'var(--one-color-background-intensity-low)',}}>
              <OwcTypography style={{padding:'0.1rem'}} variant="title6">Agreement Filters</OwcTypography>
          </div>

      <div style={{ padding: '0.1rem 0' }}>

        {/* Affiliate Row */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '0.3rem',
          }}
        >
          <div style={{ width: '200px' }}>
            <OwcTypography style={{ fontWeight: '500' }}>
              Affiliate
            </OwcTypography>
          </div>

          <select
            value={selectedAffiliate}
            onChange={(ev) =>
              this.setState({ selectedAffiliate: ev.target.value })
            }
            style={{ height: '3em', minWidth: '250px' }}
          >
            <option value="0">All</option>
            { affiliateList.map( (affiliate) => (
                <option value={affiliate.refListId}>{affiliate.description}</option>
              )) 
            }

          </select>
        </div>

        {/* Published Row */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '0.3rem',
          }}
        >
          <div style={{ width: '200px' }}>
            <OwcTypography style={{ fontWeight: '500' }}>
              Published Status
            </OwcTypography>
          </div>

          <select
            value={publishedOnly}
            onChange={(ev) =>
              this.setState({ publishedOnly: ev.target.value })
            }
            style={{ height: '3em', minWidth: '250px' }}
          >
            <option value="All">All</option>
            <option value="Published Only">Published Only</option>
            <option value="Unpublished Only">Unpublished Only</option>
          </select>
        </div>

        {/* Agreement Selection */}
        <AgreementSelection
          selectedList={agreementList}
          affiliateFilter={selectedAffiliate}
          publishedFilter={publishedOnly}
          searchOnStart={true}
          resetSearch={this.state.resetAgreementControl}
          onRemoveSelectedItem={(agreementToRemove) => {
            const newAgreementList = agreementList.filter(
              agreement =>
                agreement.customerAgreementId !==
                agreementToRemove.customerAgreementId
            );
            this.setState({ agreementList: newAgreementList });
          }}
          onAddSelectedItem={(agreement) => {
            this.setState({
              agreementList: [...agreementList, agreement],
            });
          }}
        />
        </div>
      </div>
    );
  }

  renderReportButtons() {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1em',
        }}
      >
        <OwcButton style={{width:'150px'}} onclick={this.handleSubmitClick} disabled={this.state.isLoadingResults===true}>
          Generate Report
        </OwcButton>

        <OwcButton style={{width:'150px'}} variant="warning" onclick={this.handleRequestCancel} disabled={this.state.isLoadingResults!==true}>
          Cancel Request
        </OwcButton>

        <OwcButton style={{width:'150px'}} variant="warning" onclick={this.handleFormClear}>
          Clear
        </OwcButton>
      </div>
    );
  }

  renderCountrySelectionDialog() {
    return (
      <OwcModalDialog
        size="large"
        visible={this.state.countrySelectorVisible}
        cardProps={{ style: { maxWidth: '950px', maxHeight: '650px' } }}
        disableBackdropClick
        disableEscapeKeydown
      >
        <div slot="header" style={{ padding: '10px' }}>
          <OwcTypography variant="title6">
            Select the desired countries
          </OwcTypography>
        </div>

        <div style={{ padding: '10px' }}>
          <CountrySelector
            title="Countries"
            selectedCountryCodes={this.state.countryList}
            onSelectedChange={this.handleCountrySelectionChange}
          />
        </div>

        <div slot="footer" style={{ padding: '5px' }}>
          <OwcButton
            onclick={() => this.setState({ countrySelectorVisible: false })}
          >
            Close
          </OwcButton>
        </div>
      </OwcModalDialog>
    );
  }

  renderReportSpecification() {
    return (
      <div style={{ padding: '0.3rem 3rem' }}>
        <div style={{ display: 'flex', gap: '1rem' }}>
          {/* LEFT */}
          <div
            style={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              gap: '0.1rem',
            }}
          >
            {this.renderDescriptionSection()}
            {this.renderDeviceFilters()}
            {this.renderCountryFilterSection()}
          </div>

          {/* RIGHT */}
          <div
            style={{
              width: '15%',
              display: 'flex',
              justifyContent: 'flex-start',
              
            }}
          >
            {this.renderReportButtons()}
          </div>
        </div>
      </div>
    );
  }

  renderReportFilters() {
    const report = this.state.reportResults;
    const { data } = report.locationCoverageReport;
    const { appliedFilters } = data;
    const hasDeviceFilters = Object.keys(appliedFilters?.device).length > 0;
    const countryList = appliedFilters?.device?.countryList?.trim();
    let affiliateName = null;
    console.log(this.state.affiliateList);
    if (appliedFilters?.agreement?.affiliateId) {
      affiliateName = this.state.affiliateList.find(affiliate => affiliate.refListId === Number(appliedFilters.agreement.affiliateId)).description;
    }
    console.log("appliedFilters",appliedFilters);

    const countries = countryList
      ? countryList.split(',').filter(Boolean)
      : [];

    const hasCountries = countries.length > 0;
    return (
      <>
        <div>
          <OwcTypography style={{fontWeight:'500',paddingLeft:'1rem'}}>{hasDeviceFilters === false?"No ":""}Device Filters</OwcTypography>
          {appliedFilters?.device?.lastUploadSince?.trim() && (
          <div style={{ paddingLeft: '3rem', display: 'flex', flexDirection: 'column' }}>
            <OwcTypography style={{ fontWeight: '500' }}>
              Last Upload Since
            </OwcTypography>
            <OwcTypography style={{ paddingLeft: '1rem' }}>
              {appliedFilters.device.lastUploadSince}
            </OwcTypography>
          </div>
        )}
        </div>
        <div>
          {appliedFilters?.device?.installDateSince?.trim() && (
          <div style={{ paddingLeft: '3rem', display: 'flex', flexDirection: 'column' }}>
            <OwcTypography style={{ fontWeight: '500' }}>
              Install Date Since
            </OwcTypography>
            <OwcTypography style={{ paddingLeft: '1rem' }}>
              {appliedFilters.device.installDateSince} {appliedFilters?.device?.installDateBlank && "(including blank values)"}
            </OwcTypography>
          </div>
        )}
        </div>
        <div>
          {hasCountries && (
          <div>
            <OwcTypography style={{ fontWeight: '500',paddingLeft:'1rem' }}>
              Country Filter – {countries.length} countries selected
            </OwcTypography>

            <div style={{ paddingLeft: '3rem', display: 'flex', flexDirection: 'column' }}>
              <OwcTypography style={{ paddingLeft: '1rem' }}>
                {countries.join(",\u200B").replaceAll("'","")}
              </OwcTypography>
            </div>
          </div>
        )}
        </div>
        <OwcTypography style={{fontWeight:'500',paddingLeft:'1rem'}}>Agreement Filters</OwcTypography>
        <div>
          {affiliateName != null && <div style={{paddingLeft:'3rem'}}>
          <OwcTypography style={{fontWeight:'500'}}>Affiliate</OwcTypography>
            <OwcTypography style={{paddingLeft:'1rem',display:'block'}}>{affiliateName}</OwcTypography>
          </div>}
          {appliedFilters?.agreement?.published && <div style={{paddingLeft:'3rem'}}>
          <OwcTypography style={{fontWeight:'500'}}>Published</OwcTypography>
            <OwcTypography style={{paddingLeft:'1rem',display:'block'}}>{appliedFilters?.agreement?.published}</OwcTypography>
          </div>
          }
          {appliedFilters?.agreement?.agreementList && <div>
          <OwcTypography style={{fontWeight:'500',paddingLeft:'3rem'}}>Selected Agreements</OwcTypography>
            <div style={{paddingLeft:'4rem',display:'block'}}>
            <AgreementDisplayList
              selectedIdList={appliedFilters?.agreement?.agreementList.split(",")}
              size="medium"
              hideTitle={true}
            />
            </div>
          </div>
          }
        </div>
      </>
    );
  }


  renderReportSummary() {
    const report = this.state.reportResults;
    const { data } = report.locationCoverageReport;
    const { summary } = data;

    return (
      <div>
        <div style={{display:'flex',justifyContent:'space-between',paddingBottom:'8px'}}>
          <OwcTypography style={{fontSize:"1rem",fontWeight:'500'}}>Location Accounts</OwcTypography>
          <div style={{display:'flex',alignItems:'start'}}>
            <OwcTypography style={{fontSize:"1rem",fontWeight:'500'}}>Count</OwcTypography>
          </div>
        </div>
        <div style={{display:'flex',justifyContent:'space-between',paddingBottom:'8px'}}>
          <OwcTypography>With devices covered by agreements</OwcTypography>
          <div style={{display:'flex',alignItems:'start'}}>
            <OwcTypography>{summary?.locationAccounts.withDevicesCoveredByAgreements}</OwcTypography>
          </div>
        </div>
          <div style={{display:'flex',justifyContent:'space-between'}}>
          <OwcTypography>With devices not covered by agreements</OwcTypography>
          <div style={{display:'flex',alignItems:'start'}}>
            <OwcTypography>{summary?.locationAccounts.withDevicesNotCoveredByAgreements}</OwcTypography>
          </div>
        </div>
        <div style={{display:'flex',justifyContent:'space-between',paddingTop:'8px'}}>
          <OwcTypography>Of all devices</OwcTypography>
          <div style={{display:'flex',alignItems:'start'}}>
            <OwcTypography>{summary?.locationAccounts.all}</OwcTypography>
          </div>
        </div>
      </div>
    );
  }

  renderDeviceEntitlementResults() {
    const report = this.state.reportResults;
    if (!report) return null;

    return (
      <div style={{ padding: '0rem 3rem' }} >
        <div style={{display:'flex'}}>
          <div style={{width:'50%'}}>
            <OwcTypography variant='title6'>Report Filters</OwcTypography>
            {this.renderReportFilters()}
          </div>
          <div style={{minWidth:'30%'}}>
            <OwcTypography variant='title6'>Summary</OwcTypography>
            {this.renderReportSummary()}
          </div>
        </div>
        {this.renderLocationResultsTable()}
      </div>
    );
  }

 renderLocationResultsTable() {
  const report = this.state.reportResults;
  if (!report) return null;

  const { data } = report.locationCoverageReport;
  const { locationAccounts } = data;

  const {
    selectedOption,
    currentPage = 1,
    pageSize = 50,
    sortBy = 'locationAccountName',
    sortOrder = 'default',
  } = this.state;

  const isFiltered = selectedOption !== FILTER_OPTIONS.ALL;

  // ✅ Filter Logic
  let filteredAccounts = locationAccounts;

  if (selectedOption === FILTER_OPTIONS.COVERED) {
    filteredAccounts = locationAccounts.filter(
      (acc) => acc.devicesCoveredByAgreements?.length > 0
    );
  } else if (selectedOption === FILTER_OPTIONS.NOT_COVERED) {
    filteredAccounts = locationAccounts.filter(
      (acc) => acc.devicesNotCoveredByAgreements?.length > 0
    );
  }

  const getFilteredAccounts = () => {
  const { locationAccounts } = this.state.reportResults.locationCoverageReport.data;
  const { selectedOption } = this.state;

  if (selectedOption === FILTER_OPTIONS.COVERED) {
    return locationAccounts.filter((acc) => acc.devicesCoveredByAgreements?.length > 0);
  } else if (selectedOption === FILTER_OPTIONS.NOT_COVERED) {
    return locationAccounts.filter((acc) => acc.devicesNotCoveredByAgreements?.length > 0);
  }

  return locationAccounts; // All accounts
};

  // Sorting Logic
  const nullSafeCompareFn = (a, b, key) => {
    let valA, valB;

    // Map the column key to actual values
    switch (key) {
      case "locationAccountNumber":
        valA = a.accountDetails?.locationAccountNumber || '';
        valB = b.accountDetails?.locationAccountNumber || '';
        break;
      case "locationAccountName":
        valA = a.accountDetails?.locationAccountName || '';
        valB = b.accountDetails?.locationAccountName || '';
        break;
      case "address":
        valA = a.accountDetails?.address || '';
        valB = b.accountDetails?.address || '';
        break;
      case "devicesCoveredByAgreements":
        valA = a.devicesCoveredByAgreements?.length || 0;
        valB = b.devicesCoveredByAgreements?.length || 0;
        break;
      case "devicesNotCoveredByAgreements":
        valA = a.devicesNotCoveredByAgreements?.length || 0;
        valB = b.devicesNotCoveredByAgreements?.length || 0;
        break;
      default:
        valA = a[key] ?? '';
        valB = b[key] ?? '';
    }

    // Numeric comparison for numbers
    if (typeof valA === 'number' && typeof valB === 'number') return valA - valB;

    // Fallback string comparison
    return String(valA).localeCompare(String(valB));
  };

  // Sort filtered accounts
  let sortedAccounts = [...filteredAccounts];
  if (sortOrder === 'asc') {
    sortedAccounts.sort((a, b) => nullSafeCompareFn(a, b, sortBy));
  } else if (sortOrder === 'desc') {
    sortedAccounts.sort((a, b) => nullSafeCompareFn(b, a, sortBy));
  }

  // Pagination
  const totalPages = Math.ceil(sortedAccounts.length / pageSize);
  const firstIndex = (currentPage - 1) * pageSize;
  const lastIndex = firstIndex + pageSize;
  const paginatedAccounts = sortedAccounts.slice(firstIndex, lastIndex);

  return (
    <div>
      {/* Header */}
      <div style={{ padding: "8px 0px" }}>
        <OwcTypography variant='title6'>
          Report Results -{locationAccounts.length} Location accounts
        </OwcTypography>
      </div>

      {/* Controls */}
      <div style={{ display: "flex" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "1em",
            width: "50%",
          }}
        >
          <OwcTypography style={{ paddingRight: "1rem" }} variant="title7">
            <b>Show Location Accounts</b>
          </OwcTypography>

          <OwcSelectDropdown
            style={{width:"25em"}}
            value={selectedOption}
            noClearIcon={true}
            onValueChange={(e) => {
              const newValue = Array.isArray(e.detail) ? e.detail[0] : e.detail.value;
              if (newValue !== this.state.selectedOption) {
                this.setState({ selectedOption: newValue, currentPage: 1 });
              }
            }}
          >
            <OwcListItem value={FILTER_OPTIONS.ALL}>All Accounts</OwcListItem>
            <OwcListItem value={FILTER_OPTIONS.COVERED}>
              Of devices covered by an Agreement
            </OwcListItem>
            <OwcListItem value={FILTER_OPTIONS.NOT_COVERED}>
              Of devices not covered by an Agreement
            </OwcListItem>
          </OwcSelectDropdown>
        </div>

        <div
          style={{
            display: "flex",
            minWidth: "600px",
            maxWidth: "50%",
            justifyContent: "space-between",
          }}
        >
          <OwcButton
  onClick={() => {
    const filteredAccounts = getFilteredAccounts();
    const csv = this.generateCSV(filteredAccounts, "accounts");
    this.downloadCSV(
      isFiltered ? "filtered_accounts.csv" : "accounts.csv",
      csv
    );
  }}
>
  {isFiltered
    ? "Download filtered accounts csv"
    : "Download accounts csv"}
</OwcButton>

<OwcButton
  onClick={() => {
    const filteredAccounts = getFilteredAccounts();
    this.downloadDevices(filteredAccounts);
  }}
>
  {isFiltered
    ? "Download filtered devices csv"
    : "Download devices csv"}
</OwcButton>
          <OwcButton
  onClick={() => {
    const { reportResults } = this.state;
    if (!reportResults) return;

    const fileName = "location_coverage_report.json";
    const blob = new Blob(
      [JSON.stringify(reportResults, null, 2)], // pretty formatted
      { type: "application/json;charset=utf-8;" }
    );

    this.saveFile(blob, fileName);
  }}
>
  Download json
</OwcButton>
        </div>
      </div>

      {/* Table */}
      <OwcTable size="dense" elevated>
        <OwcTableHeader sticky>
          {[
            { label: "Account No", key: "locationAccountNumber", width:"15%" },
            { label: "Name", key: "locationAccountName", width:"25%" },
            { label: "Address", key: "address", width:"30%" },
            { label: "Devices covered", key: "devicesCoveredByAgreements", width:"15%" },
            { label: "Devices not covered", key: "devicesNotCoveredByAgreements", width:"15%" },
          ].map((col) => (
            <OwcTableHeaderCell
              key={col.key}
              width={col.width}
              sortable
              sortOrder={sortBy === col.key ? sortOrder : "default"}
              onSortOrderChange={(ev) =>
                this.setState({
                  sortBy: col.key,
                  sortOrder: ev.detail,
                  currentPage: 1, // reset page on sort
                })
              }
            >
              {col.label}
            </OwcTableHeaderCell>
          ))}
        </OwcTableHeader>

        <OwcTableBody>
          {paginatedAccounts.map((account, index) => (
            <OwcTableRow key={index}>
              <OwcTableCell>{account.accountDetails?.locationAccountNumber}</OwcTableCell>
              <OwcTableCell>{account.accountDetails?.locationAccountName}</OwcTableCell>
              <OwcTableCell>{account.accountDetails?.address}</OwcTableCell>
              <OwcTableCell valign="middle">
  <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
    {account.devicesCoveredByAgreements?.length || 0}

    {account.devicesCoveredByAgreements?.length > 0 && (
      <CopyToClipboardButton
  id={`covered_${account.accountDetails?.locationAccountNumber}`}
  text={this.formatDevicesForClipboard(
    account.devicesCoveredByAgreements
  )}
/>
    )}
  </div>
</OwcTableCell>
              <OwcTableCell valign="middle">
  <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
    {account.devicesNotCoveredByAgreements?.length || 0}

    {account.devicesNotCoveredByAgreements?.length > 0 && (
      <CopyToClipboardButton
  id={`notCovered_${account.accountDetails?.locationAccountNumber}`}
  text={this.formatDevicesForClipboard(
    account.devicesNotCoveredByAgreements
  )}
/>
    )}
  </div>
</OwcTableCell>
            </OwcTableRow>
          ))}
        </OwcTableBody>

        {/* Pagination */}
        <OwcComponentFooter slot="footer">
          <OwcPagination
            page={currentPage}
            total={totalPages}
            pageSize={pageSize}
            pageSizeOptions={[10, 20, 50]}
            onPageChange={(ev) => {
              const newPage = ev.detail.page;
              const newPageSize = ev.detail.pageSize;
              if (newPage !== currentPage || newPageSize !== pageSize) {
                this.setState({ currentPage: newPage, pageSize: newPageSize });
              }
            }}
          />
        </OwcComponentFooter>
      </OwcTable>
    </div>
  );
}



  render() {
    const { reportResults, userMessage } = this.state;

    return (
      <div style={{ margin: '1em 2em' }}>
        <OwcExpandable
           expanded={this.state.reportSpecExpanded}
          onExpandedChange={(ev) =>
            this.setState({ reportSpecExpanded: ev.detail })
          }
          roundedControl
          variant="transparent"
          style={{ borderTop: '2px solid gray' }}
        >
          <span slot="title">
            <OwcTypography variant="title6">
              Report Specification
            </OwcTypography>
          </span>
          <span slot="content">
            {this.renderReportSpecification()}
            <div style={{ padding: '0rem 3rem' }}>
                {this.renderAgreementFilterSection()}
            </div>
            
            </span>
        </OwcExpandable>

        {this.renderCountrySelectionDialog()}

        {userMessage?.type === 'error' && (
          <div
            style={{
              marginTop: '0.5em',
              padding: '1rem 3rem',
              color: 'red',
              borderTop: '1px solid red',
            }}
          >
            <OwcTypography style={{ color: 'red' }}>
              {userMessage.message}
            </OwcTypography>
          </div>
        )}
      {this.state.isLoadingResults && this.renderLoadingSection()}
         {reportResults && !userMessage && (
          <OwcExpandable
            expanded
            roundedControl
            variant="transparent"
            style={{ marginTop: '0.5em', borderTop: '2px solid gray' }}
          >
            <span slot="title">
              <OwcTypography variant="title6">
                Device Entitlements Results
              </OwcTypography>
            </span>
            <span slot="content">
              {this.renderDeviceEntitlementResults()}
            </span>
          </OwcExpandable>
         )} 
      </div>
    );
  }
}

export default LocationCoverageReport;
